import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { TaxesService } from 'src/app/private/services/taxes.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-taxes',
  templateUrl: './taxes.component.html',
  styleUrls: ['./taxes.component.scss']
})
export class TaxesComponent {

  searchQuery = new FormControl();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  dateQuery = new FormControl();
  center_id: any;
  totalRows = 0;
  temp: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction = 'Add';
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  btnLoading: boolean = false;
  reloading: boolean = false;
  initialLoad: boolean = true;
  closeResult = '';
  editData: any;
  deleteData: any;
  current_id_hover = '';

  displayedColumns: string[] = [
    "name",
    "rate",
    "createdAt",
    // "is_active",
    "action"
  ];

  defaultFilter = [
    "name",
    // "is_active",
  ]


  constructor(
    private localStorage: LocalStorageService,
    private api: TaxesService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private tracker: TrackingService,
  ) { }



  ngAfterViewInit() {
    console.log("table column : ", this.displayedColumns);
    this.loadData();
  }


  open(content: any) {
    this.formAction = 'Add';

    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    })
  }

  loadData() {

    try {
      merge(
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;
            let param = {
              client_id: this.localStorage.getClientId(),
            }
            return this.api
              .getAllTaxe(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            this.reloading = false;
            this.totalRows = response.length;
            if (response === null) {
              return [];
            }
            this.totalRows = response.length;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  reloadData() {
    this.reloading = true;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            console.log("client_id", this.localStorage.getClientId())
            let param = {
              client_id: this.localStorage.getClientId(),
            }

            return this.api
              .getAllTaxe(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              this.totalRows = 0;
              this.reloading = false;
              return [];
            }
            this.totalRows = response.length;
            return response;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
          },
          error: (e) => {
            this.initialLoad = false;
            this.reloading = false;
            console.error(e);
          },
          complete: () => {
            this.initialLoad = false;
            this.reloading = false;
          },
        });
    } catch (e) {
      this.initialLoad = false;
      this.reloading = false;
      console.error(e);
    }
  }

  openEdit(content: any, data: any) {
    this.formAction = 'Update';
    this.editData = data;
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }

  openDeleteEvent(content: any, data: any) {
    this.deleteData = data;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    })
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
  }

  handleDeleteTax() {

    const params = {
      id: this.deleteData.id
    }
    this.btnLoading = true;
    this.api.deleteTaxe(params).subscribe((res: any) => {
      console.log('Response:', res);
      this.toast.success('Tax Deleted Successfully');
      this.tracker.track("Delete", "Tax", `Deleted tax: ${this.deleteData.name}`);

      this.reloadData();
      this.btnLoading = false;
      this.modalService.dismissAll();
    })
  }

}

function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
